import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive } from 'vue';
import { useI18n } from '@/composables/i18n';
import useVuelidate from '@vuelidate/core';
import { minValue, maxValue, required } from '@/utils/validation';
import { helpers } from '@vuelidate/validators';


export default /*#__PURE__*/_defineComponent({
  __name: 'AutoplayIntervalModal',
  props: {
    autoplayInterval: null
  },
  emits: ['save', 'close'],
  setup(__props: any, { emit }) {

const props = __props as {
  autoplayInterval: number;
};





const { t } = useI18n();

const MIN = 15;
const MAX = 300;

const state = reactive({
  autoplayInterval: props.autoplayInterval,
});
const validations = {
  autoplayInterval: {
    required,
    minValueSimplified: minValue(MIN),
    maxValueSimplified: maxValue(MAX),
  },
};
const v$ = useVuelidate(validations, state);

async function onSubmit() {
  emit('save', state.autoplayInterval);
  closeModal();
}

function closeModal() {
  emit('close');
}

const validationMessage = computed(
  () => v$.value.autoplayInterval?.$errors[0]?.$message,
);

return { __sfc: true,props, emit, t, MIN, MAX, state, validations, v$, onSubmit, closeModal, validationMessage }
}

})